module.exports = __webpack_public_path__ + "static/img/HK.fff8a536.jpg";